import SocketIO from 'socket.io-client';


export default function (accessToken) {
  const envBaseUrl = localStorage.getItem('envBaseUrl') || process.env.BASE_URL;
  return SocketIO(`${ envBaseUrl }/chat?auth=${ accessToken }`, { transports: ['websocket'] });
}



// WEBPACK FOOTER //
// ./src/pages/chat/ws.js